var render = function render(_c,_vm){return _c('transition',{attrs:{"name":"sf-fade"}},[(_vm.props.visible)?_c('div',{ref:"overlay",class:[_vm.data.class, _vm.data.staticClass, 'sf-overlay'],on:{"click":function($event){_vm.listeners.click && _vm.listeners.click($event)}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }